import React, { useState, useEffect } from 'react';
import { ShoppingCart } from 'lucide-react';
import { cartService } from '../../services/cartService';
import CartModal from './CartModal';

function CartIcon() {
  const [cartCount, setCartCount] = useState(0);
  const [showCart, setShowCart] = useState(false);

  useEffect(() => {
    // Charger le nombre d'articles au démarrage
    updateCartCount();
    
    // Écouter les changements du panier
    const handleStorageChange = () => {
      updateCartCount();
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('cartUpdated', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cartUpdated', handleStorageChange);
    };
  }, []);

  const updateCartCount = () => {
    setCartCount(cartService.getCartCount());
  };

  return (
    <>
      <button
        onClick={() => setShowCart(true)}
        className="relative p-2 text-gray-600 hover:text-orange-600 hover:bg-orange-50 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-200 hover:shadow-lg"
        title="Panier"
      >
        <ShoppingCart className="h-6 w-6" />
        {cartCount > 0 && (
          <span className="absolute -top-1 -right-1 h-5 w-5 bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs rounded-full flex items-center justify-center shadow-lg animate-pulse">
            {cartCount > 99 ? '99+' : cartCount}
          </span>
        )}
      </button>

      {showCart && (
        <CartModal 
          onClose={() => setShowCart(false)} 
          onCartUpdate={updateCartCount}
        />
      )}
    </>
  );
}

export default CartIcon;